import React, { useState, useEffect } from "react";

import List from "./help/List";
import Form from "./help/Form";

import axiosInstance from 'utils/axiosInstance';
import { useLocalStorage } from 'utils/storage';

import { fetchTags } from "services/tags";

const Tags = ({
    setShowContent
}) => {
    const [currentState, setCurrentState] = useState('list');
    const [tags, setTags] = useLocalStorage('tags', []);
    const [tagToEdit, setTagToEdit] = useState(null);

    const handleFormSubmit = async (form) => {
        try {
            let response;

            if (form.uid) {
                response = await axiosInstance.post(`/api/tags/${form.uid}`, form);
            } else {
                response = await axiosInstance.post("/api/tags", form);
            }

            const itemInResponse = response.data.data;

            setTags((currentItems) => {
                const isEditing = currentItems.some(n => n.uid === itemInResponse.uid);

                if (isEditing) {
                    return currentItems.map(item =>
                        item.uid === itemInResponse.uid ? itemInResponse : item
                    );
                } else {
                    return [...currentItems, itemInResponse];
                }
            });

            setCurrentState('list');
        } catch (error) {
            console.error('Failed to save tag:', error);
        }
    };

    const handleDeleteItem = async (uid) => {
        try {
            await axiosInstance.delete(`/api/tags/${uid}`);

            setTags((tags) => tags.filter(n => n.uid !== uid));
        } catch (error) {
            console.error('Failed to delete tag:', error);
        }
    };

    const handleReorder = async (items) => {
        try {
            await axiosInstance.post('/api/tags/change-order', {
                tags: items.map(({ uid, order }) => ({ uid, order })),
            });

            setTags(items);
        } catch (error) {
            console.error('Failed to change order:', error);
        }
    };
    
    useEffect(() => {
        fetchTags().then((data) => {
            if (data) {
                setTags(data);
            }
        });
    }, []);

    const handleEditTag = (tag) => {
        setTagToEdit(tag);
        setCurrentState('edit');
    };

    const handleFormCancel = () => {
        setTagToEdit(null);
        setCurrentState('list');
    }

    const handleBackButton = () => {
        setShowContent(false);
    }

    const renderCurrentView = () => {
        switch (currentState) {
            case "list":
                return (
                    <List
                        items={tags}
                        onDeleteHandler={handleDeleteItem}
                        onEditHandler={handleEditTag}
                        onReorderHandler={handleReorder}
                        onBackClick={handleBackButton}
                        setCurrentState={setCurrentState}
                    />
                );
            case "add":
            case "edit":
                return (
                    <Form
                        tagToEdit={tagToEdit}
                        onFormSubmit={handleFormSubmit}
                        onCancelHandler={handleFormCancel}
                    />
                );
            default:
                return <div>Unknown state</div>;
        }
    };

    return (
        renderCurrentView()
    );
};

export default Tags;
